/* eslint-disable no-use-before-define */
import LayoutElement from '../../../../model/entity/LayoutElement';
import { isRenderableSeries, getAvailableRenderers } from '../../../../model/getAvailableRenderers';
import { setSelectedView, setLayoutGrid, setLayout, setLayoutElements, setLayoutElement, addLayoutElement, addSelectedViewToGroup,
  removeSelectedViewFromGroup, setViewsGroup, setIs3DModeEnabled, setIsMPRModeEnabled, setCurrentTool } from '../../../../actions/LayoutActions';
import { setMainStudyId } from '../../../../actions/PatientActions';
import { setStatusLayout } from '../../../../actions/StatusLayoutActions';
import { getCurrentStudy } from '../../../../util/studiesManager';
import store from '../../../../store/store';
import { sync } from '../sync';
import { createActiveViewportContext, setCrossWindowActiveViewport } from '../crossWindow2dReferenceLines';
import { LAYOUT_MPR_CONFIG, LAYOUT_VR_CONFIG, mprDefault, vrDefault } from '../renderer/Image3d/volumeInitOptions';
import { RENDER_TYPE_2D, RENDER_TYPE_3D } from '../../../../model/factoryRenderers';
import toolNames from '../../Header/Toolbar/toolNames';

// COLECCION DE FUNCIONES PARA GESTIONAR LOS VIEWPORTS que son los layoutElements


export const createLayoutElement = (StudyInstanceUID, SeriesInstanceUID, renderType, initOptions, availableRenderers) => {
  const layoutElement = new LayoutElement();
  layoutElement.StudyInstanceUID = StudyInstanceUID;
  layoutElement.SeriesInstanceUID = SeriesInstanceUID;
  layoutElement.renderType = renderType;
  layoutElement.initOptions = initOptions || {};
  layoutElement.availableRenderers = availableRenderers || [];

  return layoutElement;
}

export const updateInitOptionsAndRenderType = (elementIndex, layoutElement, initOptions, renderType) => {
  layoutElement.initOptions = initOptions;
  layoutElement.renderType = renderType;

  store.dispatch(setLayoutElement(elementIndex, layoutElement));
  const { layout } = store.getState();
  if (layout.selectedViewIndex === elementIndex) {
    setCrossWindowActiveViewport(elementIndex, createActiveViewportContext(layout, elementIndex));
  }
};

// cuando tocamos otro estudio en el explorador, ese estudio pasa a ser el main study
const changeStudy = (StudyInstanceUID) => {
  store.dispatch(setMainStudyId(StudyInstanceUID));
};


export const displayAllSeries = () => {
  // coge paciente
  const { patient, layout } = store.getState();
  const currentStudy = getCurrentStudy(patient);

  const remainingSeries = layout.elements.map((element) => element);

  store.dispatch(setLayoutElements([]));
  setLayoutMatrix(currentStudy.series.length);

  // para cada serie, crea un elemento con ids (los saca del mainstudy) y los sube al store
  currentStudy.series.forEach((series, i) => {
    remainingSeries[i] && console.log(remainingSeries[i].SeriesInstanceUID);

    if (isRenderableSeries(series, i)) {
      const availableRenderers = getAvailableRenderers(series.instances);
      const renderType = availableRenderers[0];
      const layoutElement = createLayoutElement(currentStudy.StudyInstanceUID, series.SeriesInstanceUID, renderType, {}, availableRenderers)

      store.dispatch(addLayoutElement(layoutElement));
    }
  });

  resetViewsGroup();
  store.dispatch(setSelectedView(0));
};

// coge las series del viewsGroup y hace cuadricula con ellas
export const displaySelectedSeries = () => {
  const { layout } = store.getState();
  if (layout.viewsGroup.length < 1) return;

  // hace cuadricula con las viewsGroup
  setLayoutMatrix(layout.viewsGroup.length);

  const newElements = [];

  // para cada elemento, si esta dentro de las views group, hace una nueva lista con este elemento
  layout.elements.map((element, i) => {
    if (layout.viewsGroup.includes(i)) {
      const resetElement = { ...element, isPlayingCine: false, isSynchedFrames: false };

      newElements.push(resetElement);
      store.dispatch(setSelectedView(i));
    }

    // hace una nueva config de cuadrícula con el nuevo array de los seleccionados
    store.dispatch(setLayoutElements(newElements));
  });

  // resetea grupos
  resetViewsGroup();
  store.dispatch(setSelectedView(0));

  sync();
};

// cuando haces click en una ventana
export const selectView = (index) => {
  const { layout, patient } = store.getState();
  setCrossWindowActiveViewport(index, createActiveViewportContext(layout, index));
  const { mainStudyId } = patient;

  if (layout) {
    resetViewsGroup();
    addToViewsGroup(index);
    const layoutElement = layout.elements[index];
    if (layoutElement && mainStudyId !== layoutElement.StudyInstanceUID) changeStudy(layoutElement.StudyInstanceUID);
  }
  sync();
};

// cuando cargas una nueva serie
export const selectSeries = (study, series, index) => {
  const { layout } = store.getState();
  const availableRenderers = getAvailableRenderers(series.instances);

  if (layout.is3DModeEnabled || layout.isMPRModeEnabled) {
    const currentLayoutElement = createLayoutElement(study.StudyInstanceUID, series.SeriesInstanceUID, null, {}, availableRenderers);

    if (availableRenderers.includes(RENDER_TYPE_3D)) {
      if (layout.is3DModeEnabled) {
        setLayout3DMode(currentLayoutElement);
      } else if (layout.isMPRModeEnabled) {
        setLayoutMPRMode(currentLayoutElement);
      }
    } else {
      setLayout2DMode(currentLayoutElement, availableRenderers[0]);
    }
  } else {
    try {
      const renderType = availableRenderers[0];
      const layoutElement = createLayoutElement(
        study.StudyInstanceUID,
        series.SeriesInstanceUID,
        renderType,
        {},
        availableRenderers
      );

      store.dispatch(setLayoutElement(index, layoutElement));
      store.dispatch(setStatusLayout({}));

      selectView(index);
    } catch (err) {
      console.error('error selecting series: ', err);
    }
  }
};

// select particular grid (2x1, 2x2, 3x2 ....)
export const displayGridModel = (columns, rows) => {
  store.dispatch(setLayoutGrid(columns, rows));
};

// el switch a pantalla completa
export const changeFullViews = () => {
  const { layout, statusLayout } = store.getState();
  const key = layout.selectedViewIndex;
  selectView(key);
  if (isFullView(layout)) {
    // back to multi screen
    statusLayout !== undefined && statusLayout.elements !== undefined && statusLayout.elements.length >= 1 && store.dispatch(setLayout(statusLayout));
  } else {
    // save old layout and go to full screen
    store.dispatch(setStatusLayout(layout));
    layout.elements.length >= 1 && store.dispatch(setLayoutGrid(1, 1));
  }
};

// pregunta si hay pantalla completa
export const isFullView = (layout) => layout.columns < 2 && layout.rows < 2;

// resetea el grupo de vistas seleccionado
export const resetViewsGroup = () => {
  store.dispatch(setViewsGroup([]));
  sync();
};

// añade una vista al grupo de seleccionados
export const addToViewsGroup = (index) => {
  const { viewsGroup } = store.getState().layout;
  store.dispatch(setSelectedView(index));
  !viewsGroup.includes(index) ? store.dispatch(addSelectedViewToGroup(index)) : store.dispatch(removeSelectedViewFromGroup(index));
  sync();
};

// crea una cuadrícula a partir de un número (de series)
export const setLayoutMatrix = (n) => {
  if (n < 36) {
    let rows = Math.floor(Math.sqrt(n));
    let columns = Math.floor(n / rows);

    if (rows * columns < n) {
      ++columns;
      if (rows * columns < n) ++rows;
    }

    store.dispatch(setLayoutGrid(columns, rows));
  } else {
    store.dispatch(setLayoutGrid(6, 6));
  }
};

export const setLayout2DMode = (currentLayoutElement, renderType = RENDER_TYPE_2D) => {

  store.dispatch(setLayoutGrid(1,1));

  store.dispatch(setIs3DModeEnabled(false));
  store.dispatch(setIsMPRModeEnabled(false));

  currentLayoutElement.renderType = renderType;
  currentLayoutElement.initOptions = {};

  store.dispatch(setLayoutElements([currentLayoutElement]));
  store.dispatch(setSelectedView(0));
  selectView(0);
};


const setLayoutElementsByConfig = (currentLayoutElement, renderType, layoutConfig) => {
  const layoutElements = layoutConfig.map((initOptions) => {
    const layoutElement = createLayoutElement(currentLayoutElement.StudyInstanceUID, currentLayoutElement.SeriesInstanceUID,
      renderType, initOptions, currentLayoutElement.availableRenderers);
    return layoutElement;
  });

  store.dispatch(setLayoutElements(layoutElements));
};

export const setLayout3DMode = (currentLayoutElement) => {
  setLayoutMatrix(9);
  setLayoutElementsByConfig(currentLayoutElement, RENDER_TYPE_3D, LAYOUT_VR_CONFIG);
  store.dispatch(setCurrentTool(toolNames.CROSS_REFERENCE));
  selectView(0);
};

export const setLayoutMPRMode = (currentLayoutElement) => {
  displayGridModel(3, 2);
  setLayoutElementsByConfig(currentLayoutElement, RENDER_TYPE_3D, LAYOUT_MPR_CONFIG);
  selectView(0);
};

const setSingleLayout = (currentLayoutElement, renderType, initOptions) => {
  displayGridModel(1, 1);

  updateInitOptionsAndRenderType(0, currentLayoutElement, initOptions, renderType);
  selectView(0);
};

export const setLayout3DModeMobile = (currentLayoutElement) => {
  setSingleLayout(currentLayoutElement, RENDER_TYPE_3D, vrDefault);
  store.dispatch(setCurrentTool(toolNames.WWWC));
};

export const setLayoutMPRModeMobile = (currentLayoutElement) => {
  setSingleLayout(currentLayoutElement, RENDER_TYPE_3D, mprDefault);
};
